// FAQ Accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.accordion-item.w-dropdown');
  
  accordionItems.forEach(function(item) {
    const toggle = item.querySelector('.accordion-toggle.w-dropdown-toggle');
    const list = item.querySelector('.accordion-list.w-dropdown-list');
    const icon = item.querySelector('.accordion-icon');
    
    if (!toggle || !list) return;
    
    // Set initial state
    list.style.display = 'none';
    toggle.setAttribute('aria-expanded', 'false');
    
    // Click handler
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      
      // Close all other accordions
      accordionItems.forEach(function(otherItem) {
        if (otherItem !== item) {
          const otherToggle = otherItem.querySelector('.accordion-toggle.w-dropdown-toggle');
          const otherList = otherItem.querySelector('.accordion-list.w-dropdown-list');
          const otherIcon = otherItem.querySelector('.accordion-icon');
          
          if (otherToggle && otherList) {
            otherList.style.display = 'none';
            otherToggle.setAttribute('aria-expanded', 'false');
            if (otherIcon) {
              otherIcon.style.transform = 'rotate(0deg)';
            }
            otherItem.classList.remove('w--open');
          }
        }
      });
      
      // Toggle current accordion
      if (isOpen) {
        list.style.display = 'none';
        toggle.setAttribute('aria-expanded', 'false');
        if (icon) {
          icon.style.transform = 'rotate(0deg)';
        }
        item.classList.remove('w--open');
      } else {
        list.style.display = 'block';
        toggle.setAttribute('aria-expanded', 'true');
        if (icon) {
          icon.style.transform = 'rotate(180deg)';
        }
        item.classList.add('w--open');
      }
    });
    
    // Keyboard support
    toggle.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle.click();
      }
    });
  });
});

